module.exports = __webpack_public_path__ + "img/active-package-bg.96878e8.png";